export default {
  line: "Talian",
  language: "Bahasa",
  common: [
    "Perkhidmatan",
    "Batalkan Penggantungan",
    "Robot",
    "Tugas automatik",
    "Mula",
    "Bilangan tugas yang tinggal hari ini",
    "Nombor automatik",
    "Hanya tersedia untuk ahli premium, sila tingkatkan",
    "Sila tetapkan bilangan tugas automatik"
  ],
  upload: [
    "Memuat naik...",
    "Format yang salah",
    "Berjaya dimuat naik",
    "Muatnaik gagal"
  ],
  appMsg: [
    "Bersedia untuk memuat turun kemas kini...",
    "Muat turun telah selesai, sama ada untuk memasang pakej kemas kini",
    "Muat turun kemas kini gagal",
    "{num}% dimuat turun",
    "Mengemas kini...",
    "Kemas kini berjaya dan akan dimulakan semula tidak lama lagi",
    "Kemas kini gagal",
    "Tekan sekali lagi untuk keluar dari aplikasi"
  ],
  vanPull: [
    "Tiada Lagi Data",
     "Tiada data"
  ],
  login: {
    text: [
      "Ingat kata laluan",
       "Membalak...",
       "Log masuk sekarang",
       "Lupa kata laluan",
       "Log Masuk Mudah Alih",
       "Log Masuk E-mel"
    ],
    placeholder: [
      "Sila masukkan nombor telefon",
      "Sila masukkan kata laluan log masuk",
      "Sila masukkan alamat e-mel"
    ],
    i18n: [
      "Tiada akaun {title}?",
       "Daftar"
    ]
  },
  register: {
    text: [
      "Selamat mendaftar",
       "Penghantaran kod SMS...",
       "Dapatkan kod SMS",
       "Mendaftar...",
       "Daftar sekarang",
       "Ada akaun, muat turun sekarang",
       "Daftar Mudah Alih",
       "Daftar E-mel",
       "Dapatkan Kod Pengesahan",
       "Kod Pengesahan SMS",
       "Kod Pengesahan E-mel",
       "Hantar semula Kod Pengesahan"
    ],
    placeholder: [
      "Sila masukkan nombor telefon anda",
       "Sila masukkan kod pengesahan SMS",
       "Sila masukkan kata laluan log masuk",
       "Sila sahkan kata laluan anda",
       "Sila masukkan kod jemputan",
       "Dua kata laluan berbeza",
       "Sila masukkan kod pengesahan"
    ],
    i18n: [
      "Ada akaun?",
       "Log masuk"
    ],
    tips: "Tutorial Daftar"
  },
  footer: [
    "Rumah",
     "Video",
     "Sembang",
     "Sembang",
     "Saya",
     "Keuntungan",
     "Crowdfunding",
     "Dinamik",
     "Aktiviti"
  ],
  home: {
    broadcast: "Tahniah kepada ahli {member} kerana mengesyorkan {grade} untuk mendapatkan ganjaran promosi {currency}{reward}!",
    menu: [
      "Kawasan VIP",
       "Tutorial video",
       "Ganjaran kenaikan pangkat",
       "Media koperasi",
       "Kekuatan syarikat",
       "Insurans akaun"
    ],
    taskHall: {
      title: [
        "Dewan tugas",
         "Dewan Perniagaan"
      ]
    },
    memberList: {
      title: "Senarai Keahlian",
      data: [
        "Tahniah {member}",
         "Tonton {num} video hari ini dan peroleh {currency}{profit}!"
      ]
    },
    businessList: {
      title: "Senarai Pedagang",
      data: [
        "{member}",
        "Lepaskan {num} tugasan tunggal hari ini"
      ]
    },
    noticeTitle: "Pengumuman terkini",
    msg: "Tugas tidak terbuka",
    video: "Tiada tutorial video",
    title: ["Profil Syarikat","Tahap Keahlian"]
  },
  postTask: {
    navBar: {
      title: "Misi pelepasan",
      right: "Peraturan pelepasan"
    },
    field: [{
        label: "Task classification",
      },
      {
        label: "Task title",
        placeholder: "Please enter a task title",
        error: "Task title cannot be empty"
      },
      {
        label: "Task Brief",
        placeholder: "Please enter a task description"
      },
      {
        label: "Task unit price",
        placeholder: "Please enter the task unit price",
        error: "Task unit price cannot be empty"
      },
      {
        label: "Number received",
        placeholder: "Please enter the number",
        error: "The quantity cannot be empty"
      },
      {
        label: "Number of receipts",
        placeholder: "Please enter the number of receipts",
        right: "Times/person",
        error: "The number of receipts cannot be empty"
      },
      {
        label: "Total task price",
        error: "The total task price is not calculated"
      },
      {
        label: "Link information",
        placeholder: "Please enter the link address",
        error: "Link information cannot be empty"
      },
      {
        label: "Task level",
      },
      {
        label: "Deadline",
        placeholder: "Click to select date",
        error: "Deadline cannot be empty"
      },
      {
        label: "Conditions of completion",
        error: "Please select a completion condition"
      },
      {
        label: "Upload requirements",
        placeholder: "Please enter upload request",
      },
      { 
        label: "Sample audit",
      },
      {
        label: "Steps",
        placeholder: "Easy to understand steps help to complete!",
        error: "Operation step cannot be empty",
        img: "Step diagram is not perfect"
      },
    ],
    button: "Submit",
    step: {
      title: "Steps",
      left: "Cancel",
      right: "Completed",
      placeholder: "Please enter a step description",
      button: [
        "Delete",
        "Add"
      ]
    },
    tips: [
      "Platform handling fee {pump}{br}This release will require payment of about {price},Please ensure that the balance of the account is sufficient {a}{br}Tip: This platform prohibits the release of pornography, gambling, drugs and all other legal prohibited content, such as deduction points, blocked account.",
      "To recharge",
      "Keep at least one step",
      "Add up to ten steps"
    ]
  },
  vip: {
    user: {
      title: [
        "Tahap Semasa",
         "Pelawat"
      ],
      label: "Tugasan harian",
      value: [
        "Tempoh sah",
         "Kesahan Kekal",
         "Sila log masuk dahulu",
         "Hari",
         "Tarikh luput"
      ],
    },
    list: {
      label: "Tugas harian <b>{number}</b> kali",
      button: [
        "Aktifkan sekarang",
         "Pembaharuan Segera"
      ],
      text: [
        "Keuntungan Harian",
         "Pendapatan bulanan",
         "Ganjaran Pengesyoran: Semua orang",
         "Percuma",
         "Setiap pesanan"
      ]
    },
    dialog: [
      "Adakah anda pasti membelanjakan {currency} {amount} untuk menjadi {name}?",
       "Anda kini {currname} dan tidak boleh {name}",
       "Adakah anda pasti membelanjakan {currency} {amount} untuk memperbaharui {name}?"
    ],
    more: "Lihat lagi",
    top: [
      "Diperlukan untuk naik taraf",
      "Rebat beli",
      ["Tahap 1", "Tahap 2", "Tahap 3"],
      ["Harga","Butiran"],
      "Tamat tempoh"
    ]
  },
  user: {
    title: [
      "Tugas Saya",
       "Rekod Peribadi"
    ],
    default: [
      "Saya",
       "Akaun",
       "Kod Jemputan",
       "Keluar log masuk",
       "Seimbang",
       "Emas",
       "Dompet saya",
       "Meterai",
       "Sekatan",
       "Baik",
       "Cemerlang",
       "Atasan saya"
    ],
    grid: [
      "Seimbang",
       "Pendapatan Semalam",
       "Pendapatan hari ini",
       "Pendapatan Minggu Ini",
       "Pendapatan Bulan Ini",
       "Pendapatan Bulan Lalu",
       "Jumlah pendapatan",
       "Tonton Hari Ini(PCE)",
       "Tugas Baki Hari Ini(PCE)",
       "Suruhanjaya hari ini",
       "Rebat hari ini",
       ["Hari ini","Semalam","Minggu","Bulan"],
       ["Lihat Pendapatan","Naikkan Pendapatan","Pendapatan Crowdfunding"],
       ["Daftar Minggu Ini", "Daftar Sah Minggu Ini", "Jumlah Gaji"],
       ["Hari ini","Semalam","Tiga hari"]
    ],
    menu: [
      "Tonton Rekod",
       "Tugas Audit",
       "Lepaskan Urus",
       "Maklumat peribadi",
       "Pengikatan Akaun",
       "Kenyataan Harian",
       "Rekod perakaunan",
       "Menjemput kawan-kawan",
       "Laporan Pasukan",
       "Buku Bantuan",
       "Pusat Kredit",
       "Muat turun APP"
    ]
  },
  userInfo: {
    default: [
      "Maklumat peribadi",
       "Potret kepala",
       "Nombor telefon",
       "Kad bank",
       "Alipay",
       "Pensijilan Nama Sebenar",
       "Kata laluan log masuk",
       "Kata laluan dana",
       "Klik Tetapan",
       "Tukar potret kepala",
       "Tukar kata laluan log masuk",
       "Tukar kata laluan dana",
       "Serahkan",
       "Kosongkan cache",
       "Dompet USDT",
       "Tolak Suis",
       "Alamat Saya"
    ],
    label: [
      "Kata laluan log masuk asal",
       "Kata laluan log masuk baharu",
       "Sahkan kata laluan",
       "kata laluan dana asal",
       "kata laluan dana baharu",
       "Sahkan kata laluan",
       "Terlupa kata laluan dana",
       "Kod pengesahan SMS",
       "Sahkan kod"
    ],
    placeholder: [
      "Sila masukkan kata laluan log masuk asal",
       "Sila masukkan kata laluan log masuk baharu",
       "Sila sahkan kata laluan log masuk",
       "Sila masukkan kata laluan dana asal",
       "Sila masukkan kata laluan dana baharu",
       "Sila sahkan kata laluan dana"
    ]
  },
  userSet: {
    default: [
      "Pensijilan Nama Sebenar",
       "Maklumat terperinci",
       "Ikat Alipay",
       "Serahkan",
       "Ikat Dompet USDT"
    ],
    label: [
      "Nama sebenar",
       "QQ",
       "Akaun Alipay",
       "Nama Alipay",
       "Jenis Dompet",
       "Alamat Dompet",
       "Alamat",
       "Hubungi",
       "Telefon"
    ],
    placeholder: [
      "Sila masukkan nama sebenar (Nama saya digunakan untuk pengeluaran tunai)",
       "Masukkan nombor QQ",
       "Sila masukkan akaun Alipay",
       "Sila masukkan nama Alipay",
       "Sila pilih jenis dompet",
       "Sila masukkan alamat dompet",
       "Sila masukkan alamat terperinci",
       "Sila sahkan nama sebenar anda dahulu",
       "Sila ikat telefon anda dahulu"
    ],
    tips: "Peringatan: Kad bank yang terikat tidak boleh diubah suai, ia digunakan untuk pengeluaran anda"
  },
  bindAccount: {
    default: [
      "Ikatan Akaun",
       "Lihat tutorial",
       "Serah"
    ],
    tabs: [
      "Akaun",
       "Akaun",
       "Akaun"
    ],
    label: [
      "Arahan",
       "Tambah tangkapan skrin",
       "Akaun"
    ],
    placeholder: "Sila masukkan akaun {account} anda"
  },
  bankCard: {
    default: [
      "Ikat kad bank",
       "Sahkan sekarang",
       "Menyerahkan ...",
       "Tambah sekarang",
       "Tambah"
    ],
    tips: [
      "Sila tambah kad bank anda selepas pengesahan nama sebenar",
       "Nama pembukaan akaun kad bank terikat anda mestilah sama dengan nama sebenar anda yang disahkan, jika tidak, anda tidak akan berjaya mengeluarkannya."
    ],
    label: [
      "Nama",
       "Nama bank",
       "Akaun bank",
       "Kod IFSC"
    ],
    placeholder: [
      "Sila pilih nama bank",
       "Sila masukkan akaun Bank",
       "Sila masukkan kod IFSC"
    ]
  },
  wallet: {
    default: [
      "Dompet saya",
       "Cas semula",
       "Mengeluarkan",
       "Rekod cas semula",
       "Rekod pengeluaran",
       "R",
       "W",
       "Alipay"
    ],
    label: [
      "Kaedah pengeluaran",
       "Jumlah pengeluaran",
       "Kata laluan dana",
       "Serahkan",
       "Nombor telefon",
       "E-mel",
       "IFSC"
    ],
    placeholder: [
      "Pilih kaedah pengeluaran",
       "Sila masukkan jumlah pengeluaran",
       "Sila masukkan kata laluan dana",
       "Sila pilih kaedah pengeluaran",
       "Sila masukkan nombor telefon mudah alih penerima",
       "Sila masukkan alamat e-mel penerima",
       "Sila masukkan penerima IFSC"
    ],
    msg: [
      "Anda belum menetapkan kod wang lagi, sila tetapkan dahulu",
       "Anda belum mengikat kad bank, sila ikat dahulu"
    ]
  },
  recharge: {
    default: [
      "Cas semula",
       "Butiran cas semula",
       "Rekod cas semula",
       "Baki yang tersedia {wang}, sila pilih kaedah cas semula",
       "Jumlah minimum tunggal ialah {mata wang} {min}, maksimum {mata wang} {maks}, yuran pengendalian {yuran}%",
       "Menyerahkan...",
       "Cas semula sekarang",
       "Kembali",
       "Memuatkan..."
    ],
    label: [
      "Jumlah cas semula",
       "Saluran cas semula",
       "Nama pemindahan",
       "Nama Pembayar",
       "Telefon Mudah Alih Pembayar",
       "Akaun UPI Pembayar",
       "E-mel Pembayar"
    ],
    placeholder: [
      "Sila masukkan jumlah caj semula",
       "Sila pilih saluran cas semula",
       "Sila masukkan nama pemindahan",
       "Jumlah minimum tunggal ialah {mata wang} {min}",
       "Jumlah maksimum tunggal ialah {mata wang} {maks}",
       "Sila masukkan nama pembayar",
       "Sila masukkan nombor telefon mudah alih pembayar, awalan nombor dengan kod kawasan antarabangsa, seperti +86",
       "Sila masukkan akaun UPI pembayar",
       "Sila masukkan alamat e-mel pembayar",
    ],
    info: [
      "Jumlah cas semula",
       "Nombor pesanan",
       "Bank",
       "Nombor akaun",
       "Nama",
       "Salinan",
       "{type} Transfer",
       "Pindahkan tangkapan skrin",
       "Serahkan",
       "Kod IFSC",
       "UPI",
       "Arahan pemprosesan",
       "Alamat Dompet",
       "Resit Kod QR"
    ],
    tips: [
      "Sila pilih kaedah berikut untuk memindahkan jumlah yang sepadan bagi mengelakkan kelewatan dalam semakan kewangan.<br>Selepas pemindahan, sila muat naik tangkapan skrin pemindahan sebagai sijil pengesahan",
       "Tidak perlu menambah rakan, imbas kod QR untuk memindahkan wang kepada saya",
       "Sila lengkapkan pemindahan mengikut maklumat di bawah",
       "Petunjuk: Selepas pembayaran berjaya, sila hubungi perkhidmatan dalam talian untuk memberikan nombor akaun ahli anda, jumlah caj semula, nombor pesanan, nombor akaun pendeposit, masa caj semula, memudahkan jabatan kewangan menambah dana untuk anda tepat pada masanya.",
       "Nota: sila serahkan satu pembayaran untuk setiap pemindahan",
       "Selepas pemindahan, sila muat naik tangkapan skrin pemindahan sebagai sijil pengesahan",
       "Sila pilih kaedah berikut untuk memindahkan jumlah yang sepadan",
       "Sila muat naik tangkapan skrin pemindahan",
       "Kadar Pertukaran:{price}×{rate}={currency}<b>{money}</b>,(1USDT={currency}{rate})"
    ]
  },
  task: {
    default: [
      "Tonton Rekod",
       "Keperluan tugas",
       "Buat",
       "Audit",
       "Buka pautan",
       "Salin pautan",
       "Harga seunit",
       "Serahkan",
       "Pengecualian",
       "Masa Tonton"
    ],
    tabs: [
      "Melakukan",
       "Audit",
       "Selesai",
       "Gagal",
       "Niat jahat",
       "Ditinggalkan"
    ],
    msg: "Sila muat naik gambar yang telah siap",
    info: [
      "Butiran tugas",
       "Tajuk tugas",
       "Faedah tugas",
       "Huraian tugas",
       "Keperluan muat naik",
       "Serahkan sampel",
       "Pengguna tidak menyerahkan sampel",
       "Nota audit",
       "Tarikh audit",
       "Pihak permintaan",
       "Lepaskan",
       "Salinan",
       "Lompat",
       "Langkah tugas",
       "Langkah {index}",
       "Sampel audit",
       "Tiada sampel audit",
       "Pemuatan data...",
       "Lepaskan tugas",
       "Mula Menonton",
       "Terbitkan kandungan"
    ],
    index: [
      "Status semasa",
       "Penilaian semasa anda ialah <i style=\"color:#1989fa\">{currVip}</i><br>hanya boleh menuntut <i style=\"color:#1989fa\">{currVip}< semasa /i> tugas peringkat<br>adakah anda mahu sertai <i style=\"color:#dd6161\">{vip}</i> level",
       "Sertai sekarang",
       "Sila pilih kategori tugasan"
    ],
    list: [
      "Senarai tugas",
       "Pihak permintaan",
       "Baki",
       "Permintaan",
       "Menerima"
    ],
    show: [
      "Butiran tugas",
       "Manusia telah memperolehnya",
       "Baki {num} tempat",
       "Audit dalam masa 48 jam",
       "Huraian tugas",
       "Pihak permintaan",
       "Standard audit",
       "Salinan",
       "Lompat",
       "Langkah tugas",
       "Langkah {index}",
       "Sampel audit",
       "Tiada sampel audit",
       "Pemuatan data...",
       "Menyerahkan...",
       "Kumpul tugas",
       "Log masuk sekarang",
       "Terbitkan kandungan"
    ]
  },
  audit: {
    default: [
      "Tugas audit",
       "Terima pengguna",
       "Tarikh ambil",
       "Tarikh kemas kini",
       "Audit",
    ],
    tabs: [
      "Melakukan",
       "Audit",
       "Selesai",
       "Gagal"
    ],
    info: [
      "Butiran audit",
       "Tajuk tugas",
       "Jumlah tugas",
       "Orang selesai",
       "Baki {num} tempat",
       "Huraian tugas",
       "Maklumat pautan",
       "Sampel audit",
       "Kumpul pengguna",
       "Terima",
       "Status penyiapan",
       "Serahkan sampel",
       "Pengguna tidak menyerahkan sampel",
       "Tarikh kemas kini",
       "Pemuatan data...",
       "Berniat jahat",
       "Percubaan semula",
       "Kegagalan",
       "Kejayaan",
       "Tugas audit",
       "Arahan audit",
       "Sila masukkan perihalan audit",
       "Sekiranya tugasan yang diserahkan tidak layak, ia perlu diserahkan semula untuk semakan",
       "Tahniah atas penyempurnaan tugasan",
       "Ralat tangkapan skrin halaman tugas yang diserahkan, tugasan gagal",
       "Tugas penyerahan berniat jahat, tugas gagal"
    ]
  },
  postRecord: [
    "Pengurusan pelepasan",
     "Lepaskan",
     "Jumlah",
     "Selesai",
     "Tarikh akhir",
     "Audit",
     "Pembatalan",
     "Editor"
  ],
  dayReport: [
    "Kenyataan harian",
     "Jumlah hasil",
     "Misi saya",
     "Manfaat misi saya",
     "Tugas yang diselesaikan oleh orang bawahan",
     "Faedah tugas bawahan",
     "PCE",
     "30 hari lepas",
     "Kuantiti",
     "Video",
     "Bawahan",
     "Penggunaan",
     "Tarikh"
  ],
  fundRecord: {
    default: [
      "Rekod perbelanjaan",
       "Rekod cas semula",
       "Rekod hasil",
      "R",
      "I",
      "E"
    ],
    tabs: [
      "Pendapatan",
       "Perbelanjaan",
       "Caj semula"
    ]
  },
  promote: [
    ["Setiap {num} pengguna sah dijemput","Dapatkan","Tunai"],
     "Boleh ditarik balik terus",
     "Setiap {num} pengguna sah dijemput",
     ["Ganjaran Harian", "Semua orang boleh menuntut setiap hari"],
     ["Pengguna yang sah","Jemput {num} pengguna berbayar setiap hari"],
     ["Jemput","Terima","Jemput Sekarang"],
     "Anugerah Pekerja Pasukan",
     ["Ejen Bintang","Bonus","Gaji"],
     ["Orang","Permintaan","Dijemput"],
     "Pengenalan Suruhanjaya",
     ["Kongsi","Dapatkan"],
     ["Kongsi di platform sosial","Kongsi"],
     ["Recharge","Recharge sendiri","Recharge"],
     ["Perlombongan","Beli perlombongan","Beli"],
     ["Kewangan","Pelaburan dan pengurusan kewangan","Melabur"],
     ["Kongsi dengan rakan sekarang","Kod jemputan"],
     ["Salin pautan","Salin Kod Jemputan","Kod QR","Kongsi Poster"],
     "Simpan Gambar",
     "Rakan meningkatkan ganjaran VIP",
     "Butiran"
  ],
  teamReport: {
    default: [
      "Cari",
       "Imbangan pasukan",
       "Faedah pasukan",
       "Caj semula pasukan",
       "Pasukan menarik diri",
       "Bilangan caj pertama",
       "Bilangan tolakan pertama",
       "Saiz pasukan",
       "Pasukan baharu",
       "PCE",
       "Saya",
       "Pengguna",
       "Cas semula",
       "Pengeluaran",
       "Rebat",
       "Video",
       "Pilih tarikh",
       "Tiada data",
       "Jumlah Caj Semula",
       "Nombor Cas Semula",
       "Naikkan Pendapatan",
       "Jumlah bilangan VIP",
       "Ahli Aktif"
    ],
    tabs: [
      "Laporan Pasukan",
       "Pasukan saya"
    ],
    team: [
      "Tahap 1",
       "Tahap 2",
       "Tahap 3"
    ]
  },
  help: [
    "Buku Bantuan",
     "Tidak tersedia"
  ],
  credit: [
    "Pusat kredit",
     "Nota kredit",
     "Rekod kredit",
     "<p>1.Mata kredit dinilai sekali seminggu</p><p>2.Skor kredit pengguna awal:<b>60</b></p><p>3. Jika dikesan bahawa pengguna melakukan tugas untuk memuat naik imej palsu, ia akan ditolak satu hari nanti:<b>1</b>Had atas potongan mata:<b>7</b>integral</p><p>4. Jika pengguna tidak mengesan penggunaan imej palsu untuk meningkatkan<b>1</b>integral</p><p>5.Skor kredit di bawah<b>50</b>Pengeluaran tunai akan dihadkan</p> <p>6.Skor kredit di bawah<b>30</b>Bahkan bilangan tugasan mengetik</p><p>7.Skor kredit kurang daripada atau sama dengan<b>0</b>skor Akan diharamkan </p>",
     "Kredit saya",
     "Tiada rekod kredit buat masa ini"
  ],
  appDown: [
    "Muat Turun Apl",
     "Imbas kod QR untuk memuat turun aplikasi",
     "Simpan kod QR",
     "Kod QR berjaya disimpan",
     "Gagal menyimpan kod QR, sila cuba beberapa kali lagi atau simpan tangkapan skrin",
     "Salinan",
     "Muat Turun Android",
     "Muat Turun IOS",
     "Jika versi IOS tidak boleh dimuat turun seperti biasa, sila nyahpasang versi asal dan muat turun serta pasang sekali lagi. Tidak menyahpasang akan menjejaskan penggunaan"
  ],
  dialog: [
    "Petua",
     "Sahkan",
     "Menyerahkan...",
     "Salin berjaya",
     "Versi sistem IOS rendah dan tidak disokong",
     "Mendaftar...",
     "Pemuatan data...",
     "Belum dibuka, jadi nantikan",
     "Berjaya menyimpan imej",
     "Gagal menyimpan imej<br>Jika tidak berjaya, sila cuba beberapa kali atau ambil tangkapan skrin untuk disimpan",
     "Pelayar tidak menyokong, sila ambil tangkapan skrin",
     "Promosi pelaburan sedang berjalan",
      "Tiada rancangan pembayaran buat masa ini"
  ],
  lineList: [
    "Pemilihan baris",
     "Barisan semasa",
     "Barisan"
  ],
  serviceCenter: [
    "Khidmat Pelanggan",
     "Hai, perkhidmatan pelanggan eksklusif",
     "Senang berkhidmat untuk anda.",
     "Layan diri",
     "Khidmat pelanggan dalam talian",
     "Caj semula perkhidmatan pelanggan",
     "Perkhidmatan pelanggan talian",
     "Sambung",
     "Manual Bantuan",
     "Pengumuman Laman Web"
  ],
  theme: {
    title: "Switch theme",
    black: "Black Theme",
    white: "White theme",
    green: "Dark Green Theme"
  },
  Finance: [
    ["Dividen Harian", "Ekuiti Hadiah", "Pilihan Hadiah", "Subsidi Tambahan", "Kali"],
    "Beli Sekarang",
    "Butiran Kewangan",
    "Harga Pesanan",
    ["Peratus","Hari"],
    "Pesan sekarang",
    ["Baki Akaun", "Harga Seunit", "Dividen Harian", "Kitaran Projek", "Hari", "Bilangan Pembelian", "Bilangan maksimum pembelian", "Pendapatan yang dijangkakan"],
    "Serahkan",
    "Kewangan Saya",
    ["Keluarkan Faedah","Tamat","Butiran"],
    ["Adakah anda pasti menarik balik faedah, faedah akan dikira semula selepas pengeluaran", "Adakah anda pasti akan menamatkan kewangan ini"],
    "Butiran Pesanan",
    ["Jumlah Jumlah","Status Pesanan","Tarikh Beli"]
  ],
  Video: [
    ["Pelawat","Tingkatkan untuk menikmati lebih banyak faedah"],
     "Naik taraf",
     ["Pendapatan Hari Ini", "Setiap pesanan", "Untuk Mengeluarkan"],
     ["Bilangan video yang ditonton hari ini","Baki masa"],
     "Mula Menonton",
     "Log Masuk Untuk Menonton",
     "Lihat Dalam Skrin Penuh",
     "Tutup",
     ["syorkan anda untuk memuat turun","Muat Turun Percuma"],
     "Pengguna Dalam Talian Semasa",
     "Semua Selesai",
     "Sila ikat nombor telefon anda dahulu",
     "Sila ikat alamat e-mel anda dahulu"
  ],
  Disclaimer: [
    ["Saya telah membaca dan bersetuju","Penafian"],
     ["Perjanjian Log Masuk","Tidak Setuju","Setuju"]
  ],
  Withdraw: [
    "Baki {money} yang tersedia, sila pilih akaun pengeluaran",
     "Akaun pengeluaran",
     "Sila pilih akaun pengeluaran",
     "Jumlah Pengeluaran",
     "Sila masukkan jumlah pengeluaran",
     "Alamat Dompet",
     "Sila masukkan alamat dompet",
     "Kata Laluan Dana",
     "Sila masukkan kata laluan dana",
     "Tarik diri Sekarang",
     "Kadar pertukaran: {price}÷{rate}=<b>{money}</b>USDT,(1USDT={currency}{rate})",
     "Pilih Akaun Pengeluaran",
     ["Tambah Akaun Bank","Ikat Dompet USDT"],
     "Sebenarnya Diterima",
     "Nombor telefon",
     "Sila masukkan nombor telefon",
     "E-mel",
     "Sila masukkan e-mel anda",
     "UPI",
     "Sila masukkan UPI"
  ],
  Partner: [
    "Tahap Pembiayaan Orang Ramai",
     "Crowdfunding",
     ["Mulakan Crowdfunding","Sertai Crowdfunding","My Crowdfunding"],
     ["Tahap Crowdfunding","Sila pilih tahap crowdfunding"],
     ["Crowdfunding Copies","Sila pilih salinan crowdfunding"],
     ["Beli","Sila masukkan bilangan salinan yang dibeli"],
     "Jumlah Sesaham",
     "Pembiayaan Ramai Sekarang",
     ["Sedang Berlangsung","Selesai"],
     ["Pemula", "Peringkat Crowdfunding", "Salinan Crowdfunding", "Amaun Setiap Salinan", "Dibeli", "Servings", "Tambah Pada", "Untung", "Sertai", "Tarikh Crowdfunding"],
     "Peraturan Crowdfunding",
     ["Nama Crowdfunding","Sila masukkan nama crowdfunding"]
  ],
  Share: [
    "Bonus Harian",
     ["Senarai Tugas", "Pengguna berdaftar yang menipu akan diharamkan", "Kongsi"],
     ["Langkah Tugasan","Muat naik {num} kali setiap hari"],
     ["Imej kejayaan pengeluaran", "gambar penarikan berjaya dikongsi ke kumpulan rasmi", "Pengguna yang menghantar kandungan spam akan disekat", " Selepas kelulusan, ganjaran akan dikeluarkan ke akaun anda"],
     ["Sila pilih tangkapan skrin untuk dimuat naik","Sila masukkan alamat pautan {name} anda","Imej Contoh"],
     "Serah",
     "Kongsi",
     "Kongsi Pendapatan Hari Ini",
     "Arahan Langkah",
     "Kongsi Copywriting",
     "Salinan",
     "Serahkan Tangkapan Skrin Atau Pautan",
     "Batal",
     "Ganjaran tersedia",
     "Bonus"
  ],
  Community: [
    "Dinamik",
     ["Terkini","Pengeluaran","Beli","Komisen","Pendapatan"],
     ["Harga","Hasil Setiap Tontonan","Video Sehari"],
     "Beli VIP Yang Sama"
  ],
  Register: [
    "Sila masukkan alamat e-mel anda",
    ["Sila masukkan kod pengesahan e-mel","Dapatkan kod e-mel","Kod pengesahan e-mel"]
  ],
  UserInfo: [
    ["E-mel","Klik untuk mengikat"],
     ["Ikat telefon bimbit", "Ikat peti mel"],
     ["Nombor mudah alih","Sila masukkan nombor mudah alih"],
     ["E-mel","Sila masukkan e-mel"],
     "Sila ikat nombor telefon bimbit anda sebelum menarik diri",
     "Sila ikat alamat e-mel anda sebelum menarik diri",
     ["Persijilan Telegram","Tutorial"]
  ],
  Bet: [
    "Jarak {no} cabutan loteri",
    "Cabutan Menunggu",
    "Baki akaun",
    "Isu",
    "Isu",
    "Kandungan Pertaruhan",
    "Pertaruhan",
    "Jumlah",
    "Negeri",
    "Tiada catatan",
    "Keluarkan",
    "Masa",
    "Isu",
    "Nombor Menang",
    "Jumlah",
    "Pertaruhan",
    "Tahniah <em id='win_name'>{name}</em> kerana bertaruh dalam <i id='win_lottery'>{lottery}</i> dan memenangi <em id='win_money'>{currency}{price}</em>",
    "Pertaruhan<br>Saya",
    "Rekod Loteri",
    "Main",
    "Cara bermain",
    "Bilik Bersambung...",
    "Cabutan Menunggu",
    "Tidak Menang",
    "Memenangi {price}",
    "Dipadamkan",
    "Dibatalkan",
    "Berhenti",
    "Pergi Air",
    "Hantar gagal, klik mesej untuk menghantar semula",
    "Bilik pertaruhan tidak wujud",
    "Sama ada untuk mengikuti",
    "Ikut",
    "Pelayar anda tidak menyokong protokol WebSocket",
    "Komunikasi sembang gagal, cuba menyambung semula",
    "Petua,",
    "saat, kosongkan skrin",
    "Pelayar anda tidak menyokong",
    "Jenis Pertaruhan",
    "Anda tidak log masuk, sila log masuk dahulu",
    "Hanya boleh menghantar gambar",
    "Baki akaun kurang daripada {balance}, anda tidak boleh masuk ke dalam bilik, sila caj semula",
    "Trend",
    "Rasmi Web",
    "Keuntungan",
    ["Pertaruhan","Pemenang","Rebat","Keuntungan"],
    ["Hari ini","Semalam","Minggu","Bulan","Jumlah"]
  ],
  BetView: [
    "Max Odds",
    "Bonus",
    "Jumlah Pantas",
    "Pertaruhan",
    "Masukkan Jumlah",
    "Batal",
    "Kejar",
    "Pertaruhan Sekarang",
    "Memuatkan...",
    "Kandungan Pertaruhan",
    "Kemungkinan",
    "Sila masukkan jumlah pertaruhan",
    "Isu semasa tidak terbuka",
    "Menunggu undian, tidak boleh bertaruh",
    "Isu ini telah ditutup, sila bertaruh pada isu seterusnya",
    "Sila pilih kandungan pertaruhan",
    "Ikuti Pertaruhan",
    "Isu",
    "Isu",
    "Cara bermain",
    "Kandungan Pertaruhan",
    "Jumlah Pertaruhan",
    "Ikut",
    "Hanya tersedia untuk pengguna VIP"
  ],
  Coupon: [
    "Kupon",
    ["untuk digunakan", "digunakan", "tamat tempoh"],
    ["Baucar","Sah sehingga","Nilai"],
    "Pemindahan",
    ["Pilih semua","Sila masukkan nama pengguna untuk pemindahan","Sahkan","Batal"]
  ],
  Trend: [
    "Trend",
    ["30 Isu", "50 Isu", "100 Isu"],
    ["Tunggal Nombor", "Berbilang Nombor", "Saiz", "Tunggal Dan Berganda", "Nilai Jumlah|Bentuk"],
    ["Ratusan", "Sepuluh", "Satu", "Tiga Ela", "Dua Pertama", "Dua Terakhir", "Jumlah Tiga Ela"],
    ['Ratusan-Sepuluh-Satu,3', 'Ratusan,2', 'Sepuluh,2', 'Satu,2'],
    ['Ratusan-Sepuluh-Satu,3', 'Nilai Jumlah', 'Bentuk,2'],
    ["Besar","Kecil"],
    ["Berganda", "Tunggal"],
    ["Besar","Kecil","Jumlah","Berganda","Tunggal"],
    "Isu",
    ["Isu", "Nombor Muncul", "Maks Berterusan Keluar", "Maks Peninggalan", "Purata Peninggalan"]
  ],
  BlindBox: [
    "Rekod Hadiah"
  ],
  Activity: [
    "Aktiviti",
    ["Semua","Ejen","Ahli","Kerjasama Strategik","Tamat"],
    "Semak Butiran"
  ]
}